import { configureStore} from '@reduxjs/toolkit'
import rootReducer from "./reducers/index";

// Pass enhancer as the second arg, since there's no preloadedState
const store = configureStore({reducer: rootReducer});
export default store;
